
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { configureStore } from '../../store'
import App from './App'
import ErrorModal from '../components/features/share/modal/errorModal'
// import ErrorBoundary from '../components/features/share/ErrorBoundary'
import LoadingModal from '../components/features/share/modal/loadingModal'
// import Loading from '../components/features/share/loading'
import '../components/scss/index.scss'

const store = configureStore()

export default () => (
    <Provider store={store}>
        <Router>
            <React.Fragment>
                {/* <ErrorBoundary> */}
                <App />
                <ErrorModal />
                <LoadingModal />
                {/* <Loading /> */}
                {/* </ErrorBoundary> */}
            </React.Fragment>
        </Router>
    </Provider>
)


// WEBPACK FOOTER //
// ./src/app/routes/Root.js